import { PredefinedJurisdiction } from '@/modules/predefined/enums/PredefinedJurisdiction';
import { CalendarMeetingLinkFreeConsultUrlLink } from '@/modules/calendarmeetinglink/enums/CalendarMeetingLinkFreeConsultUrlLink';
import Enum from '@/modules/core/app/helpers/Enum';
import { LocaleType } from '@/modules/user/constants/LocaleType';

export class CalendarMeetingLinkFreeConsultLink extends Enum {
  static getLocalizedLink(
    jurisdictionId: number,
    locale: LocaleType = LocaleType.ENGLISH
  ): CalendarMeetingLinkFreeConsultUrlLink {
    if (jurisdictionId === PredefinedJurisdiction.QUEBEC.id) {
      return locale === LocaleType.ENGLISH
        ? CalendarMeetingLinkFreeConsultUrlLink.QUEBEC_ENGLISH
        : CalendarMeetingLinkFreeConsultUrlLink.QUEBEC_FRENCH;
    }

    return CalendarMeetingLinkFreeConsultUrlLink.ENGLISH;
  }
}
